import { createOrEditItem } from './form'

export const sendSupportLogEmail = data => async dispatch =>
  dispatch(
    createOrEditItem(data, {
      endpoint: `sendLogMail`,
    })
  )
